import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faDiscord,
  faFacebook,
  faInstagram,
  faYoutube,
  faTwitch,
  faGithub,
  faTiktok,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import { faGlobe, faEnvelope, faLink, faX } from '@fortawesome/pro-solid-svg-icons';

export type SocialPlatform = {
  id: string;
  name: string;
  icon: IconProp;
  validDomains: string[];
  brandColor: string;
};

export const SOCIAL_PLATFORMS: SocialPlatform[] = [
  {
    id: 'facebook',
    name: 'Facebook',
    icon: faFacebook,
    validDomains: ['facebook.com', 'fb.com', 'm.facebook.com', 'facebook.net'],
    brandColor: '#1877F2',
  },
  { id: 'twitter', name: 'Twitter', icon: faX, validDomains: ['twitter.com', 'x.com', 't.co'], brandColor: '#000000' },
  { id: 'instagram', name: 'Instagram', icon: faInstagram, validDomains: ['instagram.com', 'instagr.am'], brandColor: '#E1306C' },
  { id: 'youtube', name: 'YouTube', icon: faYoutube, validDomains: ['youtube.com', 'youtu.be'], brandColor: '#FF0000' },
  { id: 'twitch', name: 'Twitch', icon: faTwitch, validDomains: ['twitch.tv'], brandColor: '#9146FF' },
  { id: 'discord', name: 'Discord', icon: faDiscord, validDomains: ['discord.com', 'discord.gg'], brandColor: '#5865F2' },
  { id: 'github', name: 'GitHub', icon: faGithub, validDomains: ['github.com', 'github.io', 'github.dev'], brandColor: '#181717' },
  { id: 'tiktok', name: 'TikTok', icon: faTiktok, validDomains: ['tiktok.com', 'vm.tiktok.com', 'm.tiktok.com'], brandColor: '#000000' },
  { id: 'linkedin', name: 'LinkedIn', icon: faLinkedin, validDomains: ['linkedin.com', 'lnkd.in'], brandColor: '#0077B5' },
  { id: 'website', name: 'Website', icon: faGlobe, validDomains: [], brandColor: '#000000' },
  { id: 'email', name: 'Email', icon: faEnvelope, validDomains: [], brandColor: '#000000' },
  { id: 'other', name: 'Other', icon: faLink, validDomains: [], brandColor: '#000000' },
];

export const BANNER_IMAGES = ['/banners/banner1.png', '/banners/banner2.png', '/banners/banner3.png'];
